/* Life Style Aqua theme. Plain JS, no dependencies. Each block runs only when its markup is on the page. */
(function () {
  "use strict";
  var CFG = window.LSA || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var still = reduce || (navigator.connection && navigator.connection.saveData);
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var money = function (cents) {
    try { return new Intl.NumberFormat(CFG.locale || "en", { style: "currency", currency: CFG.currency || "INR", maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return String(cents / 100); }
  };
  var wa = function (t) { return "https://wa.me/" + CFG.wa + "?text=" + encodeURIComponent(t); };
  var json = function (id) { var el = $(id); if (!el) return []; try { return JSON.parse(el.textContent); } catch (e) { return []; } };

  /* ---------- videos play only while on screen; text reveals softly ---------- */
  var vio = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.getAttribute("src") && v.dataset.src) v.src = v.dataset.src;
        if (!v.getAttribute("src")) return;        /* nothing to play: the poster stays */
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.addEventListener("canplay", function once() { v.removeEventListener("canplay", once); v.play().catch(function () {}); }); });
      }
      else if (v.getAttribute("src")) v.pause();
    });
  }, { rootMargin: "200px" }) : null;
  var rio = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); rio.unobserve(e.target); } });
  }, { threshold: .12 }) : null;
  function watch(root) {
    $$("video[data-src]", root).forEach(function (v) {
      if (v.dataset.w || v.classList.contains("hv") || v.id === "pv" || v.classList.contains("gal-item") || v.closest(".th-win,.vwrap")) return;
      v.dataset.w = "1"; if (vio && !still) vio.observe(v);
    });
    $$(".rv", root).forEach(function (el) { if (el.dataset.r) return; el.dataset.r = "1"; rio ? rio.observe(el) : el.classList.add("in"); });
  }

  /* ---------- the page sinks: body tone follows the section in view ---------- */
  var curTone = "";
  function tone() {
    var list = $$("[data-tone]").filter(function (e) { return e !== document.body; }); if (!list.length) return;
    var y = innerHeight * .45, pick = list[0];
    list.forEach(function (s) { if (s.getBoundingClientRect().top <= y) pick = s; });
    if (pick.dataset.tone !== curTone) { curTone = pick.dataset.tone; document.body.dataset.tone = curTone; }
  }
  addEventListener("scroll", function () { requestAnimationFrame(tone); }, { passive: true }); addEventListener("resize", tone);

  /* ---------- the header firms up once the page scrolls ---------- */
  (function () {
    var bar = $(".bar"); if (!bar) return;
    var on = false;
    function set() { var want = scrollY > 24; if (want !== on) { on = want; bar.classList.toggle("stuck", on); } }
    addEventListener("scroll", function () { requestAnimationFrame(set); }, { passive: true });
    set();
  })();

  /* ---------- mobile menu ---------- */
  var mb = $("#menuBtn"), mm = $("#mnav");
  function setMenu(on) { if (!mm) return; mm.classList.toggle("on", on); mm.setAttribute("aria-hidden", String(!on)); mb.setAttribute("aria-expanded", String(on)); document.body.style.overflow = on ? "hidden" : ""; document.body.classList.toggle("menu-open", on); }
  if (mb && mm) {
    mb.onclick = function () { setMenu(!mm.classList.contains("on")); };
    mm.addEventListener("click", function (e) { if (e.target.closest("a")) setMenu(false); });
  }

  /* ---------- cart drawer on Shopify's Ajax cart API ---------- */
  var cart = null, lastFocus;
  function drawCart() {
    if (!cart) return;
    var n = $("#cartN"); if (n) n.textContent = cart.item_count; var b = $("#openCart"); if (b) b.dataset.n = cart.item_count;
    var tot = $("#total"); if (tot) tot.textContent = money(cart.total_price);
    var box = $("#items"); if (!box) return;
    box.innerHTML = cart.items.length ? cart.items.map(function (i, k) {
      var img = i.image ? i.image + (i.image.indexOf("?") > -1 ? "&" : "?") + "width=128" : "";
      return '<div class="ci"><img src="' + esc(img) + '" alt=""><div><b>' + esc(i.product_title) + '</b><div class="qty"><button type="button" data-line="' + (k + 1) + '" data-q="' + (i.quantity - 1) + '" aria-label="Fewer">−</button>' + i.quantity + '<button type="button" data-line="' + (k + 1) + '" data-q="' + (i.quantity + 1) + '" aria-label="More">+</button></div></div><span class="p">' + money(i.final_line_price) + "</span></div>";
    }).join("") : '<p class="empty">Your tank is empty.</p>';
  }
  function getCart() { return fetch(CFG.routes.cartjs, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; drawCart(); return c; }); }
  function openCart() { var d = $("#drawer"); if (!d) return; lastFocus = document.activeElement; d.classList.add("on"); d.setAttribute("aria-hidden", "false"); $("#scrim").classList.add("on"); var c = $("#closeCart"); if (c) c.focus(); }
  function closeAll() {
    var d = $("#drawer"); if (d) { d.classList.remove("on"); d.setAttribute("aria-hidden", "true"); }
    var s = $("#scrim"); if (s) s.classList.remove("on"); var f = $("#filters"); if (f) f.classList.remove("open");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var oc = $("#openCart"); if (oc) oc.onclick = function () { getCart().then(openCart); };
  var cc = $("#closeCart"); if (cc) cc.onclick = closeAll;
  var sc = $("#scrim"); if (sc) sc.onclick = closeAll;
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeAll(); setMenu(false); } });
  var items = $("#items");
  if (items) items.addEventListener("click", function (e) {
    var b = e.target.closest("[data-line]"); if (!b) return;
    fetch(CFG.routes.change, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; drawCart(); });
  });
  document.addEventListener("submit", function (e) {
    var f = e.target.closest("form[data-ajax]"); if (!f) return; e.preventDefault();
    var btn = f.querySelector("[type=submit]"); if (btn) btn.disabled = true;
    fetch(CFG.routes.add, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(f) })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res && (res.status >= 400 || res.errors)) { alert(res.description || res.message || "That could not be added."); return; } return getCart().then(openCart); })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });
  if ($("#openCart")) getCart();

  /* ---------- home: hero films cycle, the page takes the film's colour ---------- */
  function hero() {
    var a = $("#heroVid"), b = $("#heroVid2"); if (!a || !b || a.dataset.on) return; a.dataset.on = "1";
    var H = json("#hero-slides"); if (!H.length) return;
    var pair = [a, b], front = 0, cur = 0, t, vis = true, dots = $("#hdots");
    dots.innerHTML = H.map(function (h, i) { return '<button role="tab" data-i="' + i + '" aria-selected="' + (i === 0) + '" aria-label="Film ' + (i + 1) + '"></button>'; }).join("");
    if (H[0].src) { a.src = H[0].src; if (!still) a.play().catch(function () {}); }
    function go(i) {
      if (i === cur) return; cur = i; var nx = pair[1 - front], old = pair[front];
      if (H[i].poster) nx.poster = H[i].poster;
      if (!H[i].src) return;                       /* nothing to play: keep the poster up */
      nx.src = H[i].src; nx.currentTime = 0; if (!still) { var p = nx.play(); if (p && p.catch) p.catch(function () {}); }
      nx.classList.add("on"); old.classList.remove("on"); front = 1 - front;
      setTimeout(function () { if (!old.classList.contains("on")) old.pause(); }, 2000);
      var nm = $("#hname"); nm.classList.add("fade"); setTimeout(function () { nm.textContent = H[i].name; nm.classList.remove("fade"); }, 450);
      var go1 = $("#hgo"); if (go1) go1.href = H[i].link;
      $$("button", dots).forEach(function (d, k) { d.setAttribute("aria-selected", k === i); });
    }
    function loop() { clearInterval(t); if (!reduce && vis && H.length > 1) t = setInterval(function () { go((cur + 1) % H.length); }, 8500); }
    dots.addEventListener("click", function (e) { var d = e.target.closest("[data-i]"); if (d) { go(+d.dataset.i); loop(); } });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
      vis = es[0].isIntersecting; if (vis) { if (!still) pair[front].play().catch(function () {}); loop(); } else { clearInterval(t); pair.forEach(function (v) { v.pause(); }); }
    }, { threshold: .1 }).observe($("#hmedia"));
    /* colour sampling (silently skipped if the video host does not allow it) */
    var c = document.createElement("canvas"); c.width = 32; c.height = 18; var x = c.getContext("2d", { willReadFrequently: true }), root = document.documentElement, curC = [22, 48, 40], tgt = curC.slice(), on = true;
    setInterval(function () {
      var v = pair[front]; if (!on || v.readyState < 2) return;
      try { x.drawImage(v, 0, 0, 32, 18); var d = x.getImageData(0, 7, 32, 11).data, r = 0, g = 0, bl = 0, n = 0; for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; bl += d[i + 2]; n++; } tgt = [r / n, g / n, bl / n]; } catch (e) { on = false; }
    }, 500);
    (function ease() {
      curC = curC.map(function (c0, k) { return c0 + (tgt[k] - c0) * .08; });
      root.style.setProperty("--hc", curC.map(function (c0) { return Math.round(c0 * .62); }).join(","));
      root.style.setProperty("--hcd", curC.map(function (c0) { return Math.round(c0 * .34 + 10); }).join(","));
      requestAnimationFrame(ease);
    })();
  }

  /* ---------- home: the tank window ---------- */
  function tank() {
    var w = $("#thwin"); if (!w || w.dataset.on) return; w.dataset.on = "1";
    var F = json("#tank-fish"), names = $("#thnames"); if (!F.length) return;
    var vids = $$("video", w), front = 0, cur = -1, auto, seen = false;
    names.innerHTML = F.map(function (f, i) { return '<button role="tab" data-i="' + i + '" aria-selected="false" aria-label="' + esc(f.name) + '">' + (f.poster ? '<img src="' + esc(f.poster) + '" alt="" loading="lazy">' : "") + '<span>' + esc(f.name) + "</span></button>"; }).join("");
    function show(i) {
      if (i === cur) return; cur = i; var nx = vids[1 - front], old = vids[front];
      if (F[i].poster) nx.poster = F[i].poster;
      if (F[i].src) { nx.src = F[i].src; if (!still) { var p = nx.play(); if (p && p.catch) p.catch(function () {}); } }
      else { nx.removeAttribute("src"); nx.load(); }
      nx.classList.add("on"); old.classList.remove("on"); front = 1 - front;
      setTimeout(function () { if (!old.classList.contains("on")) old.pause(); }, 1700);
      $$("button", names).forEach(function (b, k) { b.setAttribute("aria-selected", k === i); });
      var act = $('button[aria-selected="true"]', names); if (act && names.scrollTo) names.scrollTo({ left: act.offsetLeft - 20, behavior: reduce ? "auto" : "smooth" });
    }
    function loop() { clearInterval(auto); if (!reduce && F.length > 1) auto = setInterval(function () { show((cur + 1) % F.length); }, 7000); }
    names.addEventListener("click", function (e) { var b = e.target.closest("[data-i]"); if (b) { show(+b.dataset.i); loop(); } });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { if (!seen) { seen = true; show(0); } else if (!still) vids[front].play().catch(function () {}); loop(); } else { clearInterval(auto); vids.forEach(function (v) { v.pause(); }); }
    }, { threshold: .2 }).observe(w);
    else show(0);
  }

  /* ---------- home: the fish, by price range ---------- */
  function fishTiers() {
    var sec = $("#fish"), grid = $("#f3grid"); if (!sec || !grid || sec.dataset.on) return; sec.dataset.on = "1";
    var cards = $$(".fc", grid), tabs = $$("#f3tabs [data-tier]"), t1 = +sec.dataset.t1, t2 = +sec.dataset.t2;
    if (!cards.length) return;
    var tier = function (p) { return p < t1 ? "a" : p <= t2 ? "b" : "c"; };
    function show(k) {
      tabs.forEach(function (b) { b.setAttribute("aria-selected", b.dataset.tier === k); });
      var n = 0; cards.forEach(function (c) { var ok = tier(+c.dataset.price) === k; c.classList.toggle("is-hidden", !ok); c.classList.toggle("feature", ok && n === 0); if (ok) n++; });
      var em = $(".theme-empty", grid); if (em) em.remove();
      if (!n) { var p = document.createElement("p"); p.className = "theme-empty"; p.textContent = "Nothing in this range right now."; grid.appendChild(p); }
    }
    tabs.forEach(function (b) { b.onclick = function () { show(b.dataset.tier); }; });
    show(["a", "b", "c"].filter(function (k) { return cards.some(function (c) { return tier(+c.dataset.price) === k; }); })[0] || "a");
  }

  /* ---------- home: the film and its steps ---------- */
  function process() {
    var pv = $("#pv"); if (!pv || pv.dataset.on) return; pv.dataset.on = "1";
    var list = $("#psteps"), lis = $$("li", list), T = lis.map(function (l) { return +l.dataset.t || 0; }), cur = -1;
    function setStep(i) { if (i === cur) return; cur = i; lis.forEach(function (l, k) { l.classList.toggle("on", k === i); l.classList.toggle("done", k < i); }); list.style.setProperty("--fill", lis.length > 1 ? i / (lis.length - 1) : 0); }
    pv.addEventListener("timeupdate", function () { var t = pv.currentTime, i = 0; T.forEach(function (s, k) { if (t >= s) i = k; }); setStep(i); var f = $("#pfill"); if (f && pv.duration) f.style.width = (t / pv.duration * 100) + "%"; });
    pv.addEventListener("ended", function () { pv.currentTime = 0; pv.play(); });
    lis.forEach(function (l, k) { $("button", l).addEventListener("click", function () { if (!pv.getAttribute("src") && pv.dataset.src) pv.src = pv.dataset.src; held = false; pv.currentTime = T[k]; setStep(k); var p = pv.play(); if (p && p.catch) p.catch(function () {}); }); });
    var pplay = $("#pplay"), held = false;
    if (pplay) {
      var psync = function () { pplay.dataset.s = pv.paused ? "play" : "pause"; pplay.setAttribute("aria-label", pv.paused ? "Play" : "Pause"); };
      pplay.addEventListener("click", function () {
        if (!pv.getAttribute("src") && pv.dataset.src) pv.src = pv.dataset.src;
        if (pv.paused) { held = false; var p = pv.play(); if (p && p.catch) p.catch(function () {}); } else { held = true; pv.pause(); }
        psync();
      });
      pv.addEventListener("play", psync); pv.addEventListener("pause", psync); psync();
    }
    var pmute = $("#pmute"), snd = $("#snd");
    var msync = function () {
      if (pmute) { pmute.dataset.s = pv.muted ? "muted" : "on"; pmute.setAttribute("aria-label", pv.muted ? "Unmute" : "Mute"); }
      if (snd) { snd.setAttribute("aria-pressed", pv.muted ? "false" : "true"); snd.textContent = pv.muted ? "Sound on" : "Sound off"; }
    };
    var toggleSound = function () {
      if (!pv.getAttribute("src") && pv.dataset.src) pv.src = pv.dataset.src;
      pv.muted = !pv.muted;
      if (pv.paused) { held = false; var p = pv.play(); if (p && p.catch) p.catch(function () {}); }
      msync();
    };
    if (pmute) pmute.addEventListener("click", toggleSound);
    if (snd) snd.addEventListener("click", toggleSound);
    pv.addEventListener("volumechange", msync); msync();
    var pbar = $(".p2film .pbar");
    if (pbar) pbar.addEventListener("click", function (e) {
      if (!pv.duration || !isFinite(pv.duration)) return;
      var r = pbar.getBoundingClientRect();
      pv.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * pv.duration;
    });
    if ("IntersectionObserver" in window && !still) new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { if (held) return; if (!pv.getAttribute("src") && pv.dataset.src) pv.src = pv.dataset.src; if (pv.getAttribute("src")) { var p = pv.play(); if (p && p.catch) p.catch(function () {}); } } else pv.pause();
    }, { threshold: .35 }).observe(pv);
    setStep(0);
  }

  /* ---------- home: ready the tank ---------- */
  function care() {
    var list = $("#c3list"), d = $("#tankdiag"); if (!list || !d || list.dataset.on) return; list.dataset.on = "1";
    var lis = $$("li", list), parts = $$(".part", d), mks = $$(".mk", d), cur = 0, t, vis = false, held = false, N = lis.length || 6;
    function set(n) { cur = n; lis.forEach(function (l, k) { l.classList.toggle("on", k === n - 1); }); parts.forEach(function (p) { p.classList.toggle("on", +p.dataset.n === n); }); mks.forEach(function (m) { m.classList.toggle("on", +m.dataset.n === n); }); }
    function loop() { clearInterval(t); if (!reduce && vis && !held) t = setInterval(function () { set(cur % N + 1); }, 4200); }
    list.addEventListener("mouseover", function (e) { var b = e.target.closest("[data-n]"); if (b) { held = true; clearInterval(t); set(+b.dataset.n); } });
    list.addEventListener("mouseleave", function () { held = false; loop(); });
    list.addEventListener("click", function (e) { var b = e.target.closest("[data-n]"); if (b) { set(+b.dataset.n); held = true; clearInterval(t); } });
    mks.forEach(function (m) { m.style.cursor = "pointer"; m.addEventListener("click", function () { set(+m.dataset.n); held = true; clearInterval(t); }); });
    set(1);
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; loop(); }, { threshold: .3 }).observe(d);
  }

  /* ---------- collection page: filter, sort, count ---------- */
  function collection() {
    var grid = $("#grid"), root = $("[data-collection]"); if (!grid || !root || root.dataset.on) return; root.dataset.on = "1";
    var cards = $$(".pc", grid).map(function (el, i) { return { el: el, i: i, price: +el.dataset.price, size: el.dataset.size, variety: el.dataset.variety, off: +el.dataset.off }; });
    if (!cards.length) return;
    var price = $("#price"), out = $("#priceOut"), lo = Math.floor(Math.min.apply(null, cards.map(function (c) { return c.price; })) / 500) * 500, hi = Math.ceil(Math.max.apply(null, cards.map(function (c) { return c.price; })) / 500) * 500;
    price.min = lo; price.max = hi; price.step = 500; price.value = hi; $("#pmin").textContent = money(lo * 100);
    var sizes = [], vars = {}, S = {}, V = {};
    cards.forEach(function (c) { if (c.size && sizes.indexOf(c.size) < 0) sizes.push(c.size); if (c.variety) vars[c.variety] = (vars[c.variety] || 0) + 1; });
    sizes.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    $("#sizes").innerHTML = sizes.map(function (s) { return '<button type="button" data-s="' + esc(s) + '" aria-pressed="false">' + esc(s) + "</button>"; }).join("");
    $("#varieties").innerHTML = Object.keys(vars).map(function (v) { return '<label><span><input type="checkbox" data-v="' + esc(v) + '"> ' + esc(v) + "</span><em>" + vars[v] + "</em></label>"; }).join("");
    var none = $("#none");
    function draw() {
      out.textContent = money(+price.value * 100);
      var m = $("#sort").value, list = cards.filter(function (c) { return c.price <= +price.value && (!Object.keys(S).length || S[c.size]) && (!Object.keys(V).length || V[c.variety]); });
      if (m === "lo") list.sort(function (a, b) { return a.price - b.price; }); else if (m === "hi") list.sort(function (a, b) { return b.price - a.price; }); else if (m === "off") list.sort(function (a, b) { return b.off - a.off; }); else list.sort(function (a, b) { return a.i - b.i; });
      cards.forEach(function (c) { c.el.style.display = "none"; });
      list.forEach(function (c) { c.el.style.display = ""; grid.appendChild(c.el); });
      $("#count").textContent = list.length; none.classList.toggle("hide", list.length > 0);
    }
    function reset() { S = {}; V = {}; price.value = hi; $$("#sizes button").forEach(function (b) { b.setAttribute("aria-pressed", "false"); }); $$("#varieties input").forEach(function (i) { i.checked = false; }); draw(); }
    price.oninput = draw; $("#sort").onchange = draw; $("#resetF").onclick = reset; $("#resetF2").onclick = reset;
    $("#sizes").onclick = function (e) { var b = e.target.closest("[data-s]"); if (!b) return; var k = b.dataset.s; if (S[k]) delete S[k]; else S[k] = 1; b.setAttribute("aria-pressed", !!S[k]); draw(); };
    $("#varieties").onchange = function (e) { var i = e.target; if (!i.dataset.v) return; if (i.checked) V[i.dataset.v] = 1; else delete V[i.dataset.v]; draw(); };
    var f = $("#filters");
    $("#fopen").onclick = function () { f.classList.add("open"); $("#scrim").classList.add("on"); };
    $("#fclose").onclick = closeAll;
    draw();
  }

  /* gallery video controls: play/pause, mute, seek, full screen */
  function galControls(gal) {
    var bar = gal && gal.querySelector(".vctl");
    if (!bar) return function () {};
    var pb = bar.querySelector('[data-v="play"]'), mb = bar.querySelector('[data-v="mute"]'),
        fb = bar.querySelector('[data-v="full"]'), sk = bar.querySelector(".vseek"),
        fl = sk.querySelector("i"), tm = bar.querySelector(".vtime"), cur = null;
    function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ":" + ("0" + (s % 60)).slice(-2); }
    function sync() {
      if (!cur) return;
      pb.dataset.s = cur.paused ? "play" : "pause"; pb.setAttribute("aria-label", cur.paused ? "Play" : "Pause");
      mb.dataset.s = cur.muted ? "muted" : "on"; mb.setAttribute("aria-label", cur.muted ? "Unmute" : "Mute");
      var d = cur.duration, t = cur.currentTime || 0, ok = d && isFinite(d);
      fl.style.width = (ok ? t / d * 100 : 0) + "%";
      tm.textContent = fmt(t) + " / " + (ok ? fmt(d) : "0:00");
      sk.setAttribute("aria-valuenow", ok ? Math.round(t / d * 100) : 0);
    }
    function seek(e) {
      if (!cur || !cur.duration || !isFinite(cur.duration)) return;
      var r = sk.getBoundingClientRect(), cx = e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
      cur.currentTime = Math.max(0, Math.min(1, (cx - r.left) / r.width)) * cur.duration; sync();
    }
    pb.onclick = function () { if (!cur) return; if (cur.paused) { var p = cur.play(); if (p && p.catch) p.catch(function () {}); } else cur.pause(); sync(); };
    mb.onclick = function () { if (!cur) return; cur.muted = !cur.muted; sync(); };
    fb.onclick = function () {
      var d = document;
      if (d.fullscreenElement || d.webkitFullscreenElement) { (d.exitFullscreen || d.webkitExitFullscreen).call(d); return; }
      if (gal.requestFullscreen) { var r = gal.requestFullscreen(); if (r && r.catch) r.catch(function () {}); }
      else if (gal.webkitRequestFullscreen) gal.webkitRequestFullscreen();
      else if (cur && cur.webkitEnterFullscreen) cur.webkitEnterFullscreen();
    };
    sk.addEventListener("click", seek);
    sk.addEventListener("keydown", function (e) {
      if (!cur || !cur.duration || !isFinite(cur.duration)) return;
      if (e.key === "ArrowRight") { cur.currentTime = Math.min(cur.duration, cur.currentTime + 5); e.preventDefault(); }
      else if (e.key === "ArrowLeft") { cur.currentTime = Math.max(0, cur.currentTime - 5); e.preventDefault(); }
      else return;
      sync();
    });
    return function (v) {
      cur = v || null; bar.hidden = !v; if (!v) return;
      if (!v.dataset.vc) {
        v.dataset.vc = "1";
        ["play", "pause", "volumechange", "timeupdate", "loadedmetadata", "durationchange", "ended"].forEach(function (ev) { v.addEventListener(ev, sync); });
      }
      sync();
    };
  }

  /* ---------- product page ---------- */
  function product() {
    var gal = $("#galMain"), th = $("#thumbs"); var q = $("#qty");
    if (gal && !gal.dataset.on) {
      gal.dataset.on = "1"; var items = $$(".gal-item", gal);
      var bindV = galControls(gal);
      function show(i) {
        items.forEach(function (it, k) {
          var on = k === i; it.style.display = on ? "" : "none"; it.classList.toggle("on", on);
          if (it.tagName === "VIDEO") { if (on) { if (!it.getAttribute("src") && it.dataset.src) it.src = it.dataset.src; if (!still && it.getAttribute("src")) it.play().catch(function () {}); } else it.pause(); }
        });
        if (th) $$("button", th).forEach(function (b, k) { b.setAttribute("aria-selected", k === i); });
         bindV(items[i] && items[i].tagName === "VIDEO" ? items[i] : null);
      }
      if (th) th.onclick = function (e) { var b = e.target.closest("[data-i]"); if (b) show(+b.dataset.i); };
      show(0);
    }
    if (q && !q.dataset.on) {
      q.dataset.on = "1"; var clamp = function () { q.value = Math.max(1, Math.min(9, parseInt(q.value, 10) || 1)); };
      $("#dec").onclick = function () { q.value = (+q.value || 1) - 1; clamp(); }; $("#inc").onclick = function () { q.value = (+q.value || 1) + 1; clamp(); }; q.onchange = clamp;
    }
  }

  /* contact form: write a copy of each message to a Google Sheet, if one is set up.
     Safari drops a request fired as the page navigates away - sendBeacon and
     fetch keepalive both - so hold the submit until the write finishes, with a
     short ceiling so a slow or unreachable script can never trap the customer. */
  function contactSheet() {
    var box = $(".cx-form[data-sheet]"); if (!box) return;
    var url = box.getAttribute("data-sheet"); if (!url) return;
    var form = $("form", box); if (!form || form.dataset.sheetOn) return;
    form.dataset.sheetOn = "1";
    form.addEventListener("submit", function (e) {
      if (form.dataset.sent) return;            /* second pass: let it through */
      e.preventDefault();
      form.dataset.sent = "1";
      var btn = $("button[type=submit]", form);
      if (btn) btn.setAttribute("aria-busy", "true");   /* not disabled: a disabled button cannot be the submitter */
      var done = false;
      /* requestSubmit fires a real submit event, so Shopify's own captcha and
         form handling still run. form.submit() would skip them and the message
         would never reach Shopify. The dataset.sent guard above stops a loop. */
      var go = function () {
        if (done) return; done = true;
        if (form.requestSubmit) form.requestSubmit(btn || undefined); else form.submit();
      };
      setTimeout(go, 2500);
      try {
        var body = new URLSearchParams(new FormData(form));
        body.append("page", location.href);
        fetch(url, { method: "POST", mode: "no-cors", body: body }).then(go, go);
      } catch (err) { go(); }
    });
  }

  /* share a product. Phones get the native share sheet, which is the good one.
     Desktop gets our own menu instead: Chrome on Windows hands off to the OS
     share panel, which often fails with "We couldn't show you all the ways you
     could share" and looks broken to the customer. */
  function shareSetup() {
    if (document.documentElement.dataset.shareOn) return;
    document.documentElement.dataset.shareOn = "1";
    var t, menu = null, I = {
      wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1-1.5-.7-2.5-1.3-3.5-2.9-.3-.4.3-.4.8-1.4.1-.2 0-.3 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.7.7-1 1.5-1 2.3.1 1 .5 1.9 1.1 2.7 1.2 1.7 2.6 2.8 4.5 3.6 1.6.7 2.2.7 3 .6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>',
      fb: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5H16.5V4.4A20 20 0 0 0 14.2 4.3c-2.3 0-3.9 1.4-3.9 4v2.2H7.8v3h2.5V21z"/></svg>',
      x:  '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M17.5 3h3l-6.6 7.5L21.8 21h-6l-4.7-6.1L5.6 21h-3l7-8L2.4 3h6.2l4.3 5.6zm-1 16h1.7L7.6 4.7H5.8z"/></svg>',
      em: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5.5" width="18" height="13" rx="2.5"/><path d="M3.8 7l8.2 6 8.2-6"/></svg>',
      ln: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M10 13.5a3.6 3.6 0 0 0 5.2.3l2.6-2.6a3.7 3.7 0 0 0-5.2-5.2l-1.5 1.5"/><path d="M14 10.5a3.6 3.6 0 0 0-5.2-.3l-2.6 2.6a3.7 3.7 0 0 0 5.2 5.2l1.5-1.5"/></svg>'
    };
    function toast(msg) {
      var el = document.querySelector(".ptoast");
      if (!el) { el = document.createElement("div"); el.className = "ptoast"; el.setAttribute("role", "status"); document.body.appendChild(el); }
      el.textContent = msg;
      requestAnimationFrame(function () { el.classList.add("on"); });
      clearTimeout(t); t = setTimeout(function () { el.classList.remove("on"); }, 2600);
    }
    function copy(url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { toast("Link copied"); }, function () { toast(url); });
        return;
      }
      try {
        var ta = document.createElement("textarea");
        ta.value = url; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
        toast("Link copied");
      } catch (e) { toast(url); }
    }
    function close() {
      if (!menu) return;
      menu.remove(); menu = null;
      document.removeEventListener("keydown", onKey);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    function row(href, icon, label) {
      return '<a role="menuitem" href="' + href + '" target="_blank" rel="noopener">' + icon + '<span>' + label + '</span></a>';
    }
    function open(btn, d) {
      close();
      var u = encodeURIComponent(d.url), txt = encodeURIComponent(d.text + " " + d.url);
      menu = document.createElement("div");
      menu.className = "pshare-menu";
      menu.setAttribute("role", "menu");
      menu.innerHTML =
        row("https://wa.me/?text=" + txt, I.wa, "WhatsApp") +
        row("https://www.facebook.com/sharer/sharer.php?u=" + u, I.fb, "Facebook") +
        row("https://twitter.com/intent/tweet?url=" + u + "&text=" + encodeURIComponent(d.text), I.x, "X") +
        row("mailto:?subject=" + encodeURIComponent(d.title) + "&body=" + txt, I.em, "Email") +
        '<button role="menuitem" type="button" data-copy>' + I.ln + "<span>Copy link</span></button>";
      document.body.appendChild(menu);
      var r = btn.getBoundingClientRect(), m = menu.getBoundingClientRect();
      var left = Math.min(Math.max(10, r.left + r.width / 2 - m.width / 2), innerWidth - m.width - 10);
      var top = r.top - m.height - 10;
      if (top < 10) top = Math.min(r.bottom + 10, innerHeight - m.height - 10);
      menu.style.left = left + "px"; menu.style.top = top + "px";
      requestAnimationFrame(function () { menu.classList.add("on"); });
      menu.addEventListener("click", function (e) {
        if (e.target.closest("[data-copy]")) { e.preventDefault(); copy(d.url); }
        close();
      });
      document.addEventListener("keydown", onKey);
      var first = menu.querySelector("a"); if (first) first.focus();
    }
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-share-url]");
      if (!b) { if (menu && !e.target.closest(".pshare-menu")) close(); return; }
      e.preventDefault();
      var d = {
        url: new URL(b.getAttribute("data-share-url"), location.href).href,
        title: b.getAttribute("data-share-title") || document.title
      };
      d.text = b.getAttribute("data-share-text") || d.title;
      /* a phone or tablet: the OS sheet is the right thing and reaches every app */
      var touch = window.matchMedia && matchMedia("(hover: none) and (pointer: coarse)").matches;
      if (touch && navigator.share) { navigator.share(d).catch(function () {}); return; }
      open(b, d);
    });
    addEventListener("resize", close);
    addEventListener("scroll", close, true);
  }

  /* Customer vlogs. One bar per tile, so this binds each wrapper separately
     rather than one bar to one video as the product gallery does. These films
     carry speech, so they start paused on their poster and play with sound on
     a tap; only one plays at a time. */
  function vlogs() {
    var wraps = $$(".vlogs .vwrap");
    if (!wraps.length) return;
    function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ":" + ("0" + (s % 60)).slice(-2); }
    var all = [];
    wraps.forEach(function (wrap) {
      var v = $("video", wrap), bar = $(".vctl", wrap), big = $(".vbig", wrap);
      if (!v || bar.dataset.on) return;
      bar.dataset.on = "1";
      all.push(v);
      var pb = $('[data-v="play"]', bar), mb = $('[data-v="mute"]', bar), fb = $('[data-v="full"]', bar),
          sk = $(".vseek", bar), fl = $("i", sk), tm = $(".vtime", bar);
      function sync() {
        pb.dataset.s = v.paused ? "play" : "pause";
        pb.setAttribute("aria-label", v.paused ? "Play" : "Pause");
        mb.dataset.s = v.muted ? "muted" : "on";
        mb.setAttribute("aria-label", v.muted ? "Unmute" : "Mute");
        var d = v.duration, t = v.currentTime || 0, ok2 = d && isFinite(d);
        fl.style.width = (ok2 ? t / d * 100 : 0) + "%";
        tm.textContent = fmt(t) + " / " + (ok2 ? fmt(d) : "0:00");
        sk.setAttribute("aria-valuenow", ok2 ? Math.round(t / d * 100) : 0);
        if (big) big.hidden = !v.paused;
        bar.hidden = v.paused && !v.currentTime;
      }
      function play() {
        all.forEach(function (o) { if (o !== v) o.pause(); });   /* one at a time */
        if (!v.getAttribute("src") && v.dataset.src) v.src = v.dataset.src;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      ["play", "pause", "volumechange", "timeupdate", "loadedmetadata", "durationchange", "ended"].forEach(function (e) {
        v.addEventListener(e, sync);
      });
      if (big) big.addEventListener("click", play);
      pb.addEventListener("click", function () { if (v.paused) play(); else v.pause(); sync(); });
      mb.addEventListener("click", function () { v.muted = !v.muted; sync(); });
      fb.addEventListener("click", function () {
        var d = document;
        if (d.fullscreenElement || d.webkitFullscreenElement) { (d.exitFullscreen || d.webkitExitFullscreen).call(d); return; }
        if (wrap.requestFullscreen) { var r = wrap.requestFullscreen(); if (r && r.catch) r.catch(function () {}); }
        else if (wrap.webkitRequestFullscreen) wrap.webkitRequestFullscreen();
        else if (v.webkitEnterFullscreen) { try { v.webkitEnterFullscreen(); } catch (err) { /* iPhone refuses before the film has data */ } }
      });
      function seek(e) {
        if (!v.duration || !isFinite(v.duration)) return;
        var r = sk.getBoundingClientRect(), cx = e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
        v.currentTime = Math.max(0, Math.min(1, (cx - r.left) / r.width)) * v.duration; sync();
      }
      sk.addEventListener("click", seek);
      sk.addEventListener("keydown", function (e) {
        if (!v.duration || !isFinite(v.duration)) return;
        if (e.key === "ArrowRight") { v.currentTime = Math.min(v.duration, v.currentTime + 5); e.preventDefault(); }
        else if (e.key === "ArrowLeft") { v.currentTime = Math.max(0, v.currentTime - 5); e.preventDefault(); }
        else return;
        sync();
      });
      sync();
    });
    /* a vlog scrolled out of view should not keep talking */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (!en.isIntersecting) en.target.pause(); });
      }, { threshold: .15 });
      all.forEach(function (v) { io.observe(v); });
    }
  }

  /* ---------- cart page: + and - submit the form ---------- */
  function cartPage() {
    var f = $("#cart-form"); if (!f || f.dataset.on) return; f.dataset.on = "1";
    var ag = $("#agree"), err = $("#agreeErr");
    f.addEventListener("click", function (e) {
      var b = e.target.closest("[data-step]"); if (!b) return; var inp = b.parentNode.querySelector("input");
      inp.value = Math.max(0, Math.min(9, (+inp.value || 0) + (+b.dataset.step)));
      if (ag) ag.required = false;   /* changing a quantity is not a checkout, so do not block it */
      f.requestSubmit();
    });
    if (ag) {
      var show = function (on) { if (err) err.hidden = !on; ag.setAttribute("aria-invalid", on ? "true" : "false"); };
      ag.addEventListener("change", function () { show(!ag.checked); });
      /* keep the native "required" guarantee but show our own message instead of the browser bubble */
      ag.addEventListener("invalid", function (e) { e.preventDefault(); show(true); ag.focus(); });
      f.addEventListener("submit", function (e) {
        var b = e.submitter;
        if (b && b.name === "checkout" && !ag.checked) { e.preventDefault(); show(true); ag.focus(); }
      });
      show(false);
    }
  }

  /* ---------- planner and authenticator hand off to WhatsApp ---------- */
  function forms() {
    var plan = $("#plan");
    if (plan && !plan.dataset.on) {
      plan.dataset.on = "1";
      var noun = plan.dataset.noun, sz = $("#psz"), bd = $("#pbd"), chips = $("#pst"), sum = $("#psum"), go = $("#pgo"), S = {};
      var upd = function () {
        var st = Object.keys(S);
        sum.textContent = "Tank " + sz.value + (st.length ? " · " + st.join(", ") : "") + " · " + bd.value;
        go.href = wa("Hi Life Style Aqua, I am looking for " + noun + ". Tank: " + sz.value + ". " + (st.length ? "I like: " + st.join(", ") + ". " : "") + "Budget: " + bd.value + ". Please send me a live video of what you have.");
      };
      chips.onclick = function (e) { var b = e.target.closest("[data-s]"); if (!b) return; var k = b.dataset.s; if (S[k]) delete S[k]; else S[k] = 1; b.setAttribute("aria-pressed", !!S[k]); upd(); };
      sz.onchange = upd; bd.onchange = upd; upd();
    }
    var af = $("#aform");
    if (af && !af.dataset.on) {
      af.dataset.on = "1";
      af.addEventListener("submit", function (e) {
        e.preventDefault(); var c = $("#chip").value.trim(), out = $("#amsg");
        if (c.replace(/\D/g, "").length < 8) { out.textContent = "Enter the chip code from your certificate."; return; }
        out.innerHTML = 'Thanks. <a href="' + wa("Hi Life Style Aqua, please confirm this chip code against your records: " + c) + '" target="_blank" rel="noopener">Send it to our team on WhatsApp</a> and we will confirm.';
      });
    }
  }

  /* category slider: the arrows appear only when the cards really overflow, so
     the cards the editor asked for still fill the row and one more turns it
     into a scroller. Auto-sliding, the interval, looping and pause-on-hover
     come off the data- attributes the section writes, so the merchant sets
     them per section in the theme editor. */
  function catRail() {
    $$(".wrail").forEach(function (rail) {
      if (rail.dataset.railed) return;
      var box = $(".wslide", rail), prev = $(".wnav.prev", rail), next = $(".wnav.next", rail);
      if (!box || !prev || !next) return;
      rail.dataset.railed = "1";
      var smooth = "scrollBehavior" in document.documentElement.style && !reduce;
      var auto = rail.dataset.auto !== "0" && !reduce;   /* reduced motion never auto-slides */
      var wait = Math.max(1500, +rail.dataset.dur || 5000);
      var loops = rail.dataset.loop !== "0";
      var hoverPause = rail.dataset.hover !== "0";
      var timer = null, resume = null, vis = true, held = false;
      function step() {
        var card = $(".wt", box), gap = parseFloat(getComputedStyle(box).columnGap) || 20;
        return card ? card.getBoundingClientRect().width + gap : box.clientWidth * .8;
      }
      function go(dx) { if (smooth) box.scrollBy({ left: dx, behavior: "smooth" }); else box.scrollLeft += dx; }
      function over() { return box.scrollWidth - box.clientWidth > 4; }
      function atEnd() { return box.scrollLeft >= box.scrollWidth - box.clientWidth - 2; }
      function stop() { clearInterval(timer); timer = null; }
      function start() {
        stop();
        if (!auto || held || !vis || !over()) return;
        timer = setInterval(tick, wait);
      }
      function tick() {
        if (!rail.isConnected) { stop(); return; }   /* the editor swapped the section out */
        if (!over()) { stop(); return; }
        if (atEnd()) {
          if (!loops) { stop(); return; }            /* sync() restarts it if the visitor scrolls back */
          if (smooth) box.scrollTo({ left: 0, behavior: "smooth" }); else box.scrollLeft = 0;
          return;
        }
        go(step());
      }
      function hold() { held = true; clearTimeout(resume); stop(); }
      function release(after) {
        clearTimeout(resume);
        resume = setTimeout(function () { held = false; start(); }, after || 0);
      }
      function sync() {
        var on = over();
        prev.hidden = !on; next.hidden = !on;
        if (!on) { stop(); return; }
        prev.disabled = box.scrollLeft <= 2;
        next.disabled = atEnd();
        if (!loops && !timer && !held && !next.disabled) start();
      }
      /* an arrow press gives the visitor a full interval before it moves again */
      prev.addEventListener("click", function () { go(-step()); hold(); release(wait); });
      next.addEventListener("click", function () { go(step()); hold(); release(wait); });
      if (hoverPause) {
        rail.addEventListener("mouseenter", hold);
        rail.addEventListener("mouseleave", function () { release(0); });
        rail.addEventListener("focusin", hold);
        rail.addEventListener("focusout", function () { release(0); });
        box.addEventListener("touchstart", hold, { passive: true });
        box.addEventListener("touchend", function () { release(wait); }, { passive: true });
      }
      box.addEventListener("scroll", sync, { passive: true });
      addEventListener("resize", function () { sync(); start(); });
      /* a slider nobody is looking at should not be spending anything */
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
        vis = es[0].isIntersecting; if (vis) start(); else stop();
      }, { threshold: .2 }).observe(rail);
      sync(); start();
      setTimeout(function () { sync(); start(); }, 500);   /* fonts and late images can change the widths */
    });
  }

  function init() { watch(document); hero(); tank(); fishTiers(); process(); care(); collection(); product(); cartPage(); contactSheet(); shareSetup(); vlogs(); catRail(); forms(); tone(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
